import { externalAxiosClient } from '../../../../utils/axiosClient';
import { makeApiRequest, type ApiResponse } from '../../../utils';
import { ExternalServicesEndpoints } from './externalServicesEndpoints';
import type { GoogleLookupResponse } from './response';

export class ExternalService {
    public async googleZipLookup(
        zip: string,
    ): Promise<ApiResponse<GoogleLookupResponse>> {
        const url = ExternalServicesEndpoints.googleZipLookup(zip);
        const httpRequest = externalAxiosClient.get(url);
        return makeApiRequest<GoogleLookupResponse>(httpRequest);
    }
}
